import React from 'react';
import { Map, Marker, Popup, TileLayer } from 'react-leaflet';
import '../../../styles/map.css';
import { Typography } from '@mui/material';

export const MultiMarkerMap = ({ positions, classes, ...props }) => {
    const centerLatitude =
        positions.reduce((accum, value) => {
            accum += value.latitude;
            return accum;
        }, 0) / positions.length;

    const centerLongitude =
        positions.reduce((accum, value) => (accum += value.longitude), 0) /
        positions.length;

    if (positions.length === 0) return <div />;
    return (
        <Map
            center={[centerLatitude, centerLongitude]}
            zoom={12}
            style={{ height: '100%', width: '100%' }}
        >
            <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {positions.map((p, idx) => (
                <Marker
                    key={`marker-${idx}`}
                    position={[p.latitude, p.longitude]}
                    icon={p.marker}
                >
                    {p.title && (
                        <Popup>
                            {p.location && (
                                <Typography variant="h6">
                                    {p.location}
                                </Typography>
                            )}
                            <p>{p.title}</p>
                        </Popup>
                    )}
                </Marker>
            ))}
        </Map>
    );
};

export default MultiMarkerMap;
